import { render, staticRenderFns } from "./BriqIcon.vue?vue&type=template&id=6eda710e&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./BriqIcon.vue?vue&type=style&index=0&id=6eda710e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6eda710e",
  null
  
)

export default component.exports